import React, { createContext, useState } from 'react';

import PersonPositionCertificationData from './PersonPositionCertificationData';

export const PersonPositionCertificationStateContext = createContext();

const PersonPositionCertificationContextProvider = ({ children }) => {
  const stateHook = useState(PersonPositionCertificationData.INITIAL_STATE);

  return (
    <PersonPositionCertificationStateContext.Provider value={stateHook}>
      {children}
    </PersonPositionCertificationStateContext.Provider>
  );
};

export default PersonPositionCertificationContextProvider;